<template>
  <button v-ripple="computedRipple" type="button" :class="classObject" @click="onClick">
    <span class="icon-btn__icon">
      <slot />
      <icon v-if="icon" :name="icon" :size="size" />
    </span>
  </button>
</template>

<script>
import icon from "../icon";
import ripple from "../../directives/ripple";

export default {
  components: {
    icon,
  },

  directives: {
    ripple,
  },

  props: {
    icon: {
      required: false,
      type: String,
      default: undefined,
    },

    /**
     * Size `50`, `100` or `200`
     */
    size: {
      required: false,
      type: Number,
      default: 50,
      validator: (val) => {
        return [50, 100, 200].indexOf(val) !== -1;
      },
    },

    /**
     * ripple
     */
    ripple: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  computed: {
    classObject() {
      return {
        "icon-btn": true,
        "icon-btn--200": this.size === 200,
        "icon-btn--100": this.size === 100,
        "icon-btn--50": this.size === 50,
      };
    },

    computedRipple() {
      if (!this.ripple) return "off";
      return "dark";
    },
  },

  methods: {
    onClick(e) {
      this.$emit("click", e);
    },
  },
};
</script>
